import { render, staticRenderFns } from "./FeatureShowScreen.vue?vue&type=template&id=017b84b3&"
import script from "./FeatureShowScreen.vue?vue&type=script&lang=js&"
export * from "./FeatureShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports